/** 気になるリストへのURL */
export const BOOK_MARK_URL =
  '/dcfront/bookmark/bookmarkList/?usrclk_searchList=PC-%sJobSearchList_searchResultFooterAddedArea_recommend' as const;

/** 求人のURLの追加クエリ */
export const ADDITIONAL_TITLE_QUERY =
  'usrclk_searchList=PC-%sJobSearchList_searchResultFooterAddedArea_recommend' as const;
